"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positionSelector = exports.positionByProductIdSelector = exports.mainAccountPositionsTotalAmountSelector = void 0;
var _reselect = require("reselect");
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var positionSelector = exports.positionSelector = (0, _reselect.createSelector)([function (state) {
  return state.user;
}, function (state) {
  return state.apexCore.position;
}], function (_ref, _ref2) {
  var selectedAccountId = _ref.selectedAccountId;
  var positions = _ref2.positions;
  return (0, _get["default"])(positions, selectedAccountId, {});
});
var positionByProductIdSelector = exports.positionByProductIdSelector = function positionByProductIdSelector(productId) {
  return (0, _reselect.createSelector)(positionSelector, function (positions) {
    var position = positions[productId];
    if (position) {
      return position;
    }
    return {};
  });
};
var mainAccountPositionsTotalAmountSelector = exports.mainAccountPositionsTotalAmountSelector = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.position.positions;
}, function (state) {
  return state.user.userInfo.AccountId;
}, function (positions, mainAccountId) {
  if (mainAccountId in positions) {
    return Object.values(positions[mainAccountId]).reduce(function (sum, p) {
      return sum + p.NotionalValue;
    }, 0);
  }
  return 0;
});